import { createStandardAction, createReducer } from "typesafe-actions";
import { resetDesktopDeviceSettingsInheritanceAndNav } from "./desktopDeviceSettings";
export type NavItem = {
  title: string;
  url: string;
};

export const setNavItem = createStandardAction("SET_NAV_ITEM")<NavItem>();
export const resetNavItems = createStandardAction("RESET_NAV_ITEMS")();
export const noNavItems = createStandardAction("NO_NAV_ITEMS")();

export type SettingsNavItemsState = {
  navItems: NavItem[];
  loading: boolean;
};

export const defaultSettingsNavItems: SettingsNavItemsState = {
  navItems: [],
  loading: true
};

export const SettingsNavItemsReducer = createReducer(defaultSettingsNavItems)
  .handleAction(setNavItem, (state, action) => {
    const alreadyExists = state.navItems.some(item => {
      return item.url === action.payload.url;
    });
    if (alreadyExists) return state;
    return {
      navItems: [...state.navItems, action.payload],
      loading: false
    };
  })
  .handleAction(resetNavItems, state => ({
    navItems: [],
    loading: true
  }))
  .handleAction(noNavItems, state => ({
    navItems: [],
    loading: false
  }))
  .handleAction(resetDesktopDeviceSettingsInheritanceAndNav, state => ({
    navItems: [],
    loading: true
  }));
